import { Badge } from '@smartgift/frontend-toolkit';

import * as S from './style';

export function MultiValue({ children, ...props }) {
  return (
    <S.MultiValueContainer>
      {props?.data?.automations?.length && <S.AutomationDot />}
      <Badge
        text={children}
        variant="contained"
        color="bgWeak"
        closable
        rounded
        size="sm"
        style={{ zIndex: 4 }}
        onClose={props.removeProps.onClick}
      />
    </S.MultiValueContainer>
  );
}
